import { Link } from "react-router-dom";
import SEO from "./SEO";

function NotFound() {
  return (
    <div className="container text-center py-5" style={{ minHeight: "60vh" }}>
      <SEO
        title="404 - הדף לא נמצא | ווטרלס"
        description="הדף שחיפשת לא נמצא. חזרו לדף הבית של ווטרלס."
        path="/404"
      />
      <h1 style={{ fontSize: "6rem", color: "#24af94" }}>404</h1>
      <h2 className="mb-4">הדף שחיפשת לא נמצא</h2>
      <p className="mb-4">
        ייתכן שהדף הוסר, שמו שונה או שהוא אינו זמין באופן זמני.
      </p>
      <Link to="/" className="btn btn-primary" style={{ backgroundColor: "#24af94", borderColor: "#24af94" }}>
        חזרה לדף הבית
      </Link>
    </div>
  );
}

export default NotFound;
